
const LIST_SHAPES = [
  {
    image: '/assets/images/product-sample/manh-mai.png',
    label: 'Mảnh mai',
    value: "slim"
  },
  {
    image: '/assets/images/product-sample/can-doi.png',
    label: 'Cân đối',
    value: "balanced"
  },
  {
    image: '/assets/images/product-sample/day-dan.png',
    label: 'Đầy đặn',
    value: "full"
  },
]

const SIZE_CHART = [
  {
    label: 'M',
    length: 71,
    chest: 51,
    shoulder: 47,
    minWeight: 54,
    maxWeight: 60,
  },
  {
    label: 'L',
    length: 73,
    chest: 53,
    shoulder: 48,
    minWeight: 61,
    maxWeight: 68,
  },
  {
    label: 'XL',
    length: 75,
    chest: 56,
    shoulder: 50,
    minWeight: 69,
    maxWeight: 79,
  },
  {
    label: '2XL',
    length: 77,
    chest: 57,
    shoulder: 51,
    minWeight: 78,
    maxWeight: 85,
  },
]
export { LIST_SHAPES, SIZE_CHART }